import { z } from 'zod';

export const commissioningThresholdPreflightFindingSchema = z.object({
  kind: z.literal('declarative_threshold_invalid'),
  severity: z.enum(['error', 'warning']),
  instanceId: z.string().uuid(),
  memberId: z.string().uuid().optional(),
  periodId: z.string().uuid().optional(),
  variableCode: z.string().optional(),
  code: z.enum([
    'definition_invalid', 'binding_missing', 'scope_invalid', 'cycle',
    'depth_limit', 'catalog_invalid', 'direction_invalid', 'target_invalid', 'source_pending', 'values_incomplete',
  ]),
  message: z.string(),
  dependencyPath: z.array(z.object({
    instanceId: z.string().uuid(), memberId: z.string().uuid(),
    periodId: z.string().uuid(), phase: z.enum(['band', 'money']),
    businessDriverId: z.string().uuid().optional(),
  }).strict()).optional(),
}).strict();
export type CommissioningThresholdPreflightFinding = z.infer<typeof commissioningThresholdPreflightFindingSchema>;
